import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import React from "react";

const gradientColors = {
  0: "grey",
  1: "darkred",
  2: "orange",
  3: "yellow",
  4: "yellowgreen",
  5: "darkgreen",
};

const manyColors = {
  0: "grey",
  1: "darkred",
  2: "red",
  3: "orangered",
  4: "orange",
  5: "gold",
  6: "yellowgreen",
  7: "green",
  8: "teal",
  9: "blue",
  10: "indigo",
  11: "purple",
  12: "magenta",
};

const binaryColors = {
  0: "darkred",
  1: "darkgreen",
};

function getNegativeColors(value) {
  value = Math.max(0, value);
  const t = Math.min(value / 5, 1);
  const r = Math.round(255 * t);
  const g = Math.round(150 * (1 - t));
  const b = 0;
  return `rgb(${r}, ${g}, ${b})`;
}

const getBadgeStyles = (value, colorMap) => ({
  backgroundColor:
    colorMap !== "negative"
      ? colorMap[value] || "grey"
      : getNegativeColors(value),
  color: value === 3 ? "black" : "white",
  padding: "4px 8px",
  borderRadius: "8px",
  display: "inline-block",
  minWidth: "50px",
  textAlign: "center",
  fontWeight: "bold",
  alignSelf: "center",
});

const CustomBadge = ({ value, colorMap }) => (
  <Badge style={getBadgeStyles(value, colorMap)}>{value}</Badge>
);

export const IgniteInsightsCols = () => {
  return [
    //General Info------------------------------------------------------------------------------------------------------------------------------------------------------------------
    {
      headerName: "Event",
      field: "event",
      width: 100,
      editable: false,
      renderCell: ({ row }) => <b>{row.event}</b>,
    },
    {
      headerName: "Team Number",
      field: "robot_number",
      width: 75,
      editable: false,
      type: "number",
      renderCell: ({ row }) => <b>{row.robot_number}</b>,
    },
    {
      headerName: "Match",
      field: "match_number",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.match_number || 0,
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.match_number}
        </Badge>
      ),
    },
    {
      headerName: "Total Points",
      field: "match_points",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.match_points || 0,
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.match_points}
        </Badge>
      ),
    },
    {
      headerName: "Auto Points",
      field: "auto_points",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.auto_points || 0,
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.auto_points}
        </Badge>
      ),
    },
    {
      headerName: "Teleop Points",
      field: "teleop_points",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_points || 0,
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.teleop_points}
        </Badge>
      ),
    },
    {
      headerName: "Endgame Points",
      field: "endgame_points",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.endgame_points || 0,
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.endgame_points}
        </Badge>
      ),
    },

    //Auto------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Starting Location",
      field: "starting_location",
      width: 100,
      editable: false,
      valueGetter: (cell) => cell.row.starting_location || "no_attempt",
      renderCell: ({ row }) => (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Badge
            style={{
              backgroundColor: "grey",
              color: "white",
              padding: "4px 8px",
              borderRadius: "8px",
              display: "inline-block",
              minWidth: "50px",
              textAlign: "center",
              fontWeight: "bold",
              alignSelf: "center",
            }}
          >
            {row.starting_location}
          </Badge>
        </Box>
      ),
    },

    //Teleop------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Level 4",
      field: "teleop_level4",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_level4 || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_level4} colorMap={manyColors} />
      ),
    },
    {
      headerName: "Level 3",
      field: "teleop_level3",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_level3 || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_level3} colorMap={manyColors} />
      ),
    },
    {
      headerName: "Level 2",
      field: "teleop_level2",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_level2 || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_level2} colorMap={manyColors} />
      ),
    },
    {
      headerName: "Level 1",
      field: "teleop_level1",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_level1 || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_level1} colorMap={manyColors} />
      ),
    },
    {
      headerName: "Coral Missed",
      field: "teleop_missed_coral",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_net_missed || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_net_missed} colorMap="negative" />
      ),
    },
    {
      headerName: "Net Scored",
      field: "teleop_net_scored",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_net_scored || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_net_scored} colorMap={manyColors} />
      ),
    },
    {
      headerName: "Net Missed",
      field: "teleop_net_missed",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_net_missed || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.teleop_net_missed} colorMap="negative" />
      ),
    },
    {
      headerName: "Processor Scored",
      field: "teleop_processor_scored",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.teleop_processor_scored || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.teleop_processor_scored}
          colorMap={manyColors}
        />
      ),
    },

    //Endgame------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Endgame",
      field: "endgame_type",
      width: 100,
      editable: false,
      valueGetter: (cell) => cell.row.endgame_type || "no_attempt",
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor:
              row.endgame_type === "no_attempt"
                ? "grey"
                : row.endgame_type === "parked"
                ? "yellow"
                : row.endgame_type === "failed_shallow"
                ? "orange"
                : row.endgame_type === "failed_deep"
                ? "red"
                : row.endgame_type === "succeeded_shallow"
                ? "green"
                : "teal",
            color: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.endgame_type}
        </Badge>
      ),
    },

    //Traits------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Speed",
      field: "robot_speed",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_speed || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.robot_speed} colorMap={gradientColors} />
      ),
    },
    {
      headerName: "Agility",
      field: "robot_agility",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_agility || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.robot_agility} colorMap={gradientColors} />
      ),
    },
    {
      headerName: "Defense",
      field: "robot_defense",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_defense || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.robot_defense} colorMap={gradientColors} />
      ),
    },
    {
      headerName: "Climbing Speed",
      field: "robot_climbing_speed",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_climbing_speed || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.robot_climbing_speed}
          colorMap={gradientColors}
        />
      ),
    },

    //Ability------------------------------------------------------------------------------------------------------------------------------------------------------------------
    {
      headerName: "Coral Can Control",
      field: "robot_coral_can_handle",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_coral_can_handle || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.robot_coral_can_handle}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Algae Can Control",
      field: "robot_algae_controlled",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_algae_controlled || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.robot_algae_controlled}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Algae Can Dislodge",
      field: "robot_dislodge_algae",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_coral_can_handle || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.robot_coral_can_handle}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Barge Can Travel Under",
      field: "robot_travel_under_barge",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_travel_under_barge || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.robot_travel_under_barge}
          colorMap={binaryColors}
        />
      ),
    },

    //Unfortunate------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Lost Comms",
      field: "errors_mistakes_lost_comms",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_mistakes_lost_comms || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_mistakes_lost_comms}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Stuck Piece",
      field: "errors_mistakes_stuck_piece",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_mistakes_stuck_piece || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_mistakes_stuck_piece}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Extra Pieces",
      field: "errors_mistakes_extra_piece",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_mistakes_extra_piece || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_mistakes_extra_piece}
          colorMap={binaryColors}
        />
      ),
    },

    //Robot------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Tippy",
      field: "robot_tippy",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_tippy || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.robot_tippy} colorMap={binaryColors} />
      ),
    },
    {
      headerName: "Tipped",
      field: "robot_tipped",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_tipped || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.robot_tipped} colorMap={binaryColors} />
      ),
    },
    {
      headerName: "Damaged",
      field: "robot_damaged",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.robot_damaged || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.robot_damaged} colorMap={binaryColors} />
      ),
    },

    //Gameplay------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "Foul",
      field: "errors_official_foul",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_official_foul || 0,
      renderCell: ({ row }) => (
        <CustomBadge value={row.errors_official_foul} colorMap={binaryColors} />
      ),
    },
    {
      headerName: "Yellow Card",
      field: "errors_official_yellow_card",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_official_yellow_card || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_official_yellow_card}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Red Card",
      field: "errors_official_red_card",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_official_red_card || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_official_red_card}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Battlebot",
      field: "errors_gameplay_battlebot",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_gameplay_battlebot || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_gameplay_battlebot}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Nuisance",
      field: "errors_gameplay_nuisance",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_gameplay_nuisance || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_gameplay_nuisance}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Touched Cage",
      field: "errors_gameplay_touched_cage",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_gameplay_touched_cage || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_gameplay_touched_cage}
          colorMap={binaryColors}
        />
      ),
    },
    {
      headerName: "Knocked Cage",
      field: "errors_gameplay_knocked_cage",
      width: 75,
      editable: false,
      type: "number",
      valueGetter: (cell) => cell.row.errors_gameplay_knocked_cage || 0,
      renderCell: ({ row }) => (
        <CustomBadge
          value={row.errors_gameplay_knocked_cage}
          colorMap={binaryColors}
        />
      ),
    },

    //User Info------------------------------------------------------------------------------------------------------------------------------------------------------------------

    {
      headerName: "User's Team Number",
      field: "user_team_number",
      width: 75,
      editable: false,
    },
    { headerName: "Username", field: "username", width: 100, editable: false },
    {
      headerName: "Year",
      field: "year",
      width: 75,
      editable: false,
    },

    {
      headerName: "Notes",
      field: "notes",
      width: 250,
      editable: false,
      valueGetter: (cell) => cell.row.notes || "no_attempt",
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "4px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.notes}
        </Badge>
      ),
    },
    {
      headerName: "Auto Actions",
      field: "auto_actions",
      width: 200,
      editable: false,
      valueGetter: (cell) => cell.row.auto_actions || "no_attempt",
      renderCell: ({ row }) => (
        <Badge
          style={{
            backgroundColor: "grey",
            color: "white",
            padding: "4px 8px",
            borderRadius: "4px",
            display: "inline-block",
            minWidth: "50px",
            textAlign: "center",
            fontWeight: "bold",
            alignSelf: "center",
          }}
        >
          {row.auto_actions}
        </Badge>
      ),
    },
  ];
};
